import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { IconButton, Stack, SvgIcon, TextField, Typography } from '@mui/material';
import Edit02Icon from '@untitled-ui/icons-react/build/esm/Edit02';

import type { FC } from 'react';
import { useEffect, useState } from 'react';
import FaIcon from 'src/icons/font-awesome/FaIcon';
type EditableTextFieldProps = {
  value?: string;
  typograhyProps: any;
  onChange: (value: string) => void;
};
export const EditableTextField: FC<EditableTextFieldProps> = (props) => {
  const [value, setValue] = useState(props.value || '');
  const [isEdit, setIsEdit] = useState(false);
  const handleEditClick = () => {
    setIsEdit(true);
  };
  const handleSaveClick = () => {
    setIsEdit(false);
    if (value !== props.value) {
      props.onChange(value);
    }
  };
  useEffect(() => {
    setValue(props.value || '');
    return () => {};
  }, [props.value]);

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
      {isEdit ? (
        <>
          <TextField
            // defaultValue={value}
            onChange={(e) => setValue(e.target.value)}
            value={value}
            // style={{ fontSize: 30, padding: 5 }}
            inputProps={{
              style: { fontSize: 30, padding: 5 },
            }}
          ></TextField>
          <IconButton onClick={handleSaveClick}>
            <FaIcon icon={faCheck}></FaIcon>
          </IconButton>
        </>
      ) : (
        <>
          <Typography {...props.typograhyProps}>{value}</Typography>
          <IconButton onClick={handleEditClick}>
            <SvgIcon fontSize="small">
              <Edit02Icon />
            </SvgIcon>
          </IconButton>
        </>
      )}
    </Stack>
  );
};
